let claimStatusHistoryCols = [
    {
        key: 'dateCreatedAsLocalTime',
        display: 'Date'
    },
    {
        key: 'createdBy',
        display: 'Created By'
    },
    {
        key: 'parentLabel',
        display: 'Parent Status'
    },
    {
        key: 'statusLabel',
        display: 'Status'
    },
    {
        key: 'approved',
        display: 'Approved Flag'
    }]

export { claimStatusHistoryCols }